<template>
  <li
    class="cube-index-list-item"
    :class="itemClass"
    @touchstart="addActiveCls"
    @touchend="removeActiveCls"
    @click="selectItem()"
  >
    <div class="cube-index-list-item-def">
      <slot>{{item.name}}</slot>
    </div>
  </li>
</template>

<script>
import { addClass, removeClass } from 'common/js/dom'

const COMPONENT_NAME = 'cube-index-list-item'
const ACTIVE_CLS = 'cube-index-list-item_active'
const EVENT_SELECT = 'select'

export default {
  name: COMPONENT_NAME,
  props: {
    item: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    itemClass() {
      return this.item.active ? ACTIVE_CLS : ''
    }
  },
  methods: {
    addActiveCls(e) {
      addClass(e.currentTarget, ACTIVE_CLS)
    },
    removeActiveCls(e) {
      removeClass(e.currentTarget, ACTIVE_CLS)
    },
    selectItem() {
      this.$emit(EVENT_SELECT, this.item)
    }
  }
}
</script>

<style lang="scss" scoped>
.cube-index-list-item {
  position: relative;
  height: 50px;
  line-height: 50px;
  padding-left: 16px;
  font-size: 14px;
  color: #333333;
  .cube-index-list-item-def {
    border-bottom: 1px solid #eeeeee;
  }
  &:last-of-type {
    .cube-index-list-item-def {
      border-bottom-color: transparent;
    }
  }
}

.cube-index-list-item_active {
  background: rgba(0, 0, 0, 0.04);
}
</style>
